import { createSelector } from 'reselect';

const encargosWorkspaceSelector = state => state.encargosWorkspace.encargos;


export const resumenPreciosSelector = createSelector(
  [encargosWorkspaceSelector],
  (encargos) => {
    let total = 0;
    encargos.forEach((encargo) => {
      const { articulos } = encargo;
      if (articulos && articulos.length > 0) {
        articulos.forEach((articulo) => {
          const { pvp } = articulo;
          total += parseFloat(pvp);
        });
      }
    });
    return {
      total,
    };
  },
);

export const articulosSeleccionadosSelector = createSelector(
  [encargosWorkspaceSelector],
  (encargos) => {
    const articulos = [];
    if (encargos) {
      encargos.forEach((encargo) => {
        encargo.articulosAgrupados.forEach((agrupacion) => {
          agrupacion.detalles.forEach((articulo) => {
            if (articulo.checked === true) {
              articulos.push({
                encargoId: encargo.id,
                lineaDetalle: articulo.linea,
                lineaDescripcion: articulo.descripcion,
                lineaPvp: articulo.total,
                lineaUds: articulo.unidades,
              });
            }
          });
        });
      });
    }
    return articulos;
  },
);
